module.exports = __webpack_public_path__ + "assets/img/mask-five-long.654f2829.png";